import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { map } from 'rxjs/operators';
import { ImpersonationSessionService } from '../../../core/services/impersonation/impersonation-session.service';

@Component({
  selector: 'app-impersonation-banner',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div
      *ngIf="isActive$ | async"
      class="relative z-[70] flex w-full items-center justify-center gap-4 bg-primary py-2 text-white"
      role="alert"
    >
      <span class="text-sm font-medium">
        Impersonating as {{ userName$ | async }} ({{ userEmail$ | async }})
      </span>
      <button
        type="button"
        class="rounded border border-white px-3 py-1 text-sm font-medium transition-colors hover:bg-white/10"
        (click)="stopImpersonation()"
      >
        Stop impersonating
      </button>
    </div>
  `,
})
export class ImpersonationBannerComponent {
  private readonly impersonationSession = inject(ImpersonationSessionService);

  readonly isActive$ = this.impersonationSession.state$.pipe(
    map((state) => state.isActive),
  );

  readonly userName$ = this.impersonationSession.state$.pipe(
    map((state) => state.userName || 'Unknown user'),
  );

  readonly userEmail$ = this.impersonationSession.state$.pipe(
    map((state) => state.userEmail || ''),
  );

  stopImpersonation(): void {
    this.impersonationSession.stopSession();
  }
}
